import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import {
  Keyboard,
  KeyboardResizeMode,
} from "@awesome-cordova-plugins/keyboard/ngx";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { CnpjModel } from "../../../shared/service/cnpj/model/cnpj.model";
import { ProfessionService } from "../../service/profession.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { DataOrigin } from "../../../shared/model/DataOrigin";
import { CnpjFactoryService } from "../../../shared/service/cnpj/cnpj-factory-service";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { CompanyInformationValidationService } from "../../../../../src/app/shared/service/cnpj/cnpj.information.service";
import { COMPANY_INFORMATION_CONSTANTS } from "./company-information.constants";

@Component({
  selector: "app-company-information",
  templateUrl: "./company-information.html",
  styleUrls: ["./company-information.scss"],
})
export class CompanyInformationComponent
  extends DefaultPageComponent
  implements OnInit
  {
  // MENSAGENS E PLACEHOLDERS

  public invalidErrorText = COMPANY_INFORMATION_CONSTANTS.ERROR_MESSAGES.INVALID_CNPJ;
  public invalidErrorCnpjText = COMPANY_INFORMATION_CONSTANTS.ERROR_MESSAGES.INCOMPLETE_CNPJ;
  public invalidErrorNameText = COMPANY_INFORMATION_CONSTANTS.ERROR_MESSAGES.INCORRECT_NAME;
  public invalidErrorNameMaxText = COMPANY_INFORMATION_CONSTANTS.ERROR_MESSAGES.MAX_CHARACTERS;
  public placeholder = "Qual o CNPJ de onde você trabalha?";
  public titlePage = "Dados profissionais";
  public placeholderName = "Qual o nome de onde você trabalha?";
    
  //IDS
  public idLabel = "company-cnpj-inf";
  public idLabelName = "company-name-inf";
  public label = "cnpj";
  public labelName = "nome da empresa";
  
  public numberCnpj = "";
  public nameCompany = "";
  public idComponentCnpj = "companyCnpj";
  public idComponentCompanyName = "companyName";
  public idLabelCnpj = "numberDocument";
  public headerId = "company-cnpj";

  textErrorCnpj = "";
  textErrorName = "";
  error = false;
  errorName = false;
  verifyMsgError = false;

  buttonEnable = false;
  labelEnable = false;
  labelInput = false;
  optional = false;
  success = false;
  savePrevious = false;

  startStage = "";
  endStage = "";

  cnpj: CnpjModel;

  dataOrigin = DataOrigin.Mobile;
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;

  idLabelCompanyInformation = "idLabelCompanyInformation";
  idButtonCompanyInformation = "idButtonCompanyInformation";

  companyCnpjForm = this.formBuilder.group({
    companyCnpj: this.formBuilder.control("", [
      FormValidations.validationsNumberCnpj,
    ]),
  });

  companyNameForm = this.formBuilder.group({
    companyName: this.formBuilder.control("", [
      FormValidations.validationsNameCnpj,
    ]),
  });

  constructor(
    private formBuilder: FormBuilder,
    private companyInformationValidationService: CompanyInformationValidationService,
    private title: Title,
    private cnpjFactoryService: CnpjFactoryService,
    private professionalService: ProfessionService,
    private keyBoard: Keyboard,
    private analyticsPageService: AnalyticsPageService,
    public router: NavController,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
    const dataOriginTrack = this.journeyService.getCurrentTrack(this.headerId)
      ?.parameters?.dataOrigin;

    this.dataOrigin = dataOriginTrack ? dataOriginTrack : this.dataOrigin;

    this.keyBoard.setResizeMode(KeyboardResizeMode.Body);
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.cnpjOptional();
    this.verifyError();
    this.editFieldInvest("empresa_cnpj", "entityCnpj", "professionalData");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    let startAndEndStage = "4";
    const track = this.journeyService.selectedTrack;
    const path = "professional-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PROFESSIONAL
    ) {
      this.startStage = startAndEndStage;
      this.endStage = startAndEndStage;
    } else {
      this.startStage = track.getIndexPage(this.headerId, path).toString();
      this.endStage = track.getTotalPage(path).toString();
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.companyInformation;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathCnpj,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  verifyCnpj() {
    this.nameCompany = "";
    const companyCnpjForm = this.companyCnpjForm.controls.companyCnpj.value;
    const cnpjValue = this.companyInformationValidationService.cleanCnpj(companyCnpjForm);
    this.labelEnable = false;
    this.success = false;

    if (this.companyInformationValidationService.validateCnpj(cnpjValue)) {
      this.edit = false;
      this.textErrorCnpj = "";
      this.cnpjFactoryService
        .getService(this.dataOrigin)
        .getCnpj(cnpjValue)
        .then((data) => {
          this.edit = true;
          this.cnpj = data;
          this.success = true;
          this.verifyError();
        })
        .catch((error) => {
          this.edit = true;
          this.error = true;
          this.textErrorCnpj = this.invalidErrorText;
          console.error('Erro ao verificar CNPJ:', error);
        });
    }
  }

  errorMsg() {
    const control = this.companyCnpjForm.get("companyCnpj") as FormControl;
    const minLengthCnpj = 14;

    if (control.value.length < minLengthCnpj) {
      this.textErrorCnpj = this.invalidErrorCnpjText;
      this.error = true;
    }else{
      this.textErrorCnpj = "";
      this.error = false;
    }
    this.verifyError();
  }

  errorMsgName() {
    const control = this.companyNameForm.get("companyName") as FormControl;
    this.errorName = control.errors !== null;

    if (control.errors !== null && control.errors.hasOwnProperty("minLength")) {
      this.textErrorName = this.invalidErrorNameText;
    }
    if (control.errors !== null && control.errors.hasOwnProperty("maxLength")) {
      this.textErrorName = this.invalidErrorNameMaxText;
    }
    if (control.errors !== null && control.errors.hasOwnProperty("nameSpace")) {
      this.textErrorName = this.invalidErrorNameText;
    }
    this.verifyError();
  }

  clickNext() {
    const cnpjValue = this.numberCnpj
      .replace("-", "")
      .replace(/[^a-z\d]+/gi, "");
    this.professionalService.setEntityCnpj(cnpjValue);
    this.professionalService.setEntityThatWorks(this.nameCompany);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.companyInformation,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  backPage() {
    this.analyticsEventClique();

    if (!this.journeyService.selectedTrack.isUncoupled()) {
      const id =
        this.journeyService.registratioJourney.data.professionalData
          .originIncome;

      this.setValuePrevious();
      if (
        (this.journeyService.journey === TrackTypes.BASIC ||
          this.journeyService.journey === TrackTypes.BASIC_V2 ||
          this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL ||
          this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL_V2 ||
          this.journeyService.journey === TrackTypes.UPDATE_PROFESSIONAL) &&
        id === COMPANY_INFORMATION_CONSTANTS.SPECIAL_ORIGIN_ID
      ) {
        this.router.navigateBack(["professional-data", "origin-income"]);
      } else {
        if (
          this.journeyService.edit ||
          this.journeyService.journey === undefined
        ) {
          this.back();
        } else {
          this.router.navigateBack(["professional-data", "profession"]);
        }
      }
    } else {
      this.back();
    }
  }

  cnpjOptional() {
    const professionalDataId =
      this.journeyService.registratioJourney.data.professionalData.originIncome;
    const idNotProf =  COMPANY_INFORMATION_CONSTANTS.NON_PROFESSIONAL_IDS;
    const filterId = idNotProf.find((idNotProfessional) => idNotProfessional === professionalDataId);
    this.optional = filterId ? true : false;
  }

  verifyError() {
    if (this.error) {
      console.log("Algum erro", this.error)
      this.buttonEnable = false;
    }
    if (this.success && !this.labelEnable) {
      if (this.cnpj === undefined || this.cnpj === null || !this.cnpj.cnpjAtivo) {
        this.buttonEnable = false;
        this.error = true;
        this.verifyMsgError = true;
        this.textErrorCnpj = this.invalidErrorText;
      } else if (this.cnpj.razaoSocial !== "") {
        this.placeholderName = "Nome da empresa";
        this.companyNameForm.controls.companyName.setValue(
          this.cnpj.razaoSocial
        );
        this.labelEnable = true;
        this.labelInput = true;
        this.nameCompany = this.cnpj.razaoSocial;
        this.buttonEnable = true;
      } else if (!this.cnpj.razaoSocial && this.cnpj.cnpjAtivo) {
        this.labelEnable = true;
        this.labelInput = false;
        this.placeholderName = "Qual o nome de onde você trabalha?";
        if (this.optional && this.nameCompany.length === 0) {
          this.buttonEnable = true;
        } else {
          this.buttonEnable = false;
        }
      }
    } else if (this.errorName) {
      this.buttonEnable = false;
    } else if (this.optional && this.numberCnpj.length === 0) {
      this.buttonEnable = true;
    } else if (this.labelEnable) {
      if (this.optional && this.nameCompany.length === 0) {
        this.buttonEnable = true;
      }
      if (this.optional && !this.errorName) {
        this.buttonEnable = true;
      } else if (!this.errorName && this.nameCompany.length > 2) {
        this.buttonEnable = true;
      }
    }
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.professionalData) {
      if (
        this.journeyService.registratioJourney.data.professionalData.entityCnpj
      ) {
        const cnpjValue =
          this.journeyService.registratioJourney.data.professionalData
            .entityCnpj;
        const cnpjNumber = cnpjValue
          .replace(/\D+/g, "")
          .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        this.numberCnpj = cnpjNumber;
        this.companyCnpjForm.controls.companyCnpj.setValue(cnpjNumber);
      }
      if (
        this.journeyService.registratioJourney.data.professionalData
          .entityThatWorks
      ) {
        this.nameCompany =
          this.journeyService.registratioJourney.data.professionalData.entityThatWorks;
        this.companyNameForm.controls.companyName.setValue(
          this.journeyService.registratioJourney.data.professionalData
            .entityThatWorks
        );
      }
      if (
        (this.journeyService.journey === TrackTypes.BASIC &&
          !this.savePrevious) ||
        (this.journeyService.journey === TrackTypes.UPDATE_PROFESSIONAL &&
          !this.savePrevious) ||
        (this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL_V2 &&
          !this.savePrevious)
      ) {
        this.savePrevious = true;
        this.journeyService.registratioJourney.data.professionalData.entityCnpjPrevious =
          this.numberCnpj;
        this.journeyService.registratioJourney.data.professionalData.entityThatWorksPrevious =
          this.nameCompany;
      }
    }
    this.verifyCnpj();
  }

  setValuePrevious() {
    if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        this.savePrevious === true) ||
      (this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL_V2 &&
        this.savePrevious === true) ||
      (this.journeyService.journey === TrackTypes.UPDATE_PROFESSIONAL &&
        this.savePrevious === true)
    ) {
      this.savePrevious = false;
      this.journeyService.registratioJourney.data.professionalData.entityCnpj =
        this.journeyService.registratioJourney.data.professionalData.entityCnpjPrevious;
      this.journeyService.registratioJourney.data.professionalData.entityThatWorks =
        this.journeyService.registratioJourney.data.professionalData.entityThatWorksPrevious;
    }
  }
}
